import { useCallback, useState } from "react";
import Form from "rc-field-form";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { Input, Label } from "reactstrap";
import Modal from "../../../../../components/Modal";
import Field from "../../../../../components/Field";
import CustomTimeInput from "../../../../../components/Inputs/CustomTimeInput";
import DateInput from "../../../../../components/Inputs/DateInput";
import Button from "../../../../../components/Button";
import { applyTimezone, combineDateAndTime } from "../../../../../utils/helpers/date";

function MissPunchModal({ visible, close, values, submit }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onCancel = useCallback(() => {
        form.resetFields();
        close();
    }, [form, close]);

    const onFinish = useCallback(async ({ endDate, note }) => {
        const { date, startDate, timezone } = values;
        let end = combineDateAndTime(moment(date), moment(endDate), timezone);
        if (moment(end).isBefore(moment(startDate), "seconds")) {
            end = moment(end).add(1, "day");
            end = applyTimezone(moment(end), values?.timezone, true);
        }
        const data = {
            timesheetId: values?.id,
            date: date,
            startDate: startDate,
            timezone: timezone,
            endDate: end.toISOString(true),
            note,
        };
        setLoading(true);
        try {
            await submit(values?.id, data);
            onCancel();
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }, [submit, values, onCancel]);

    return (
        <Modal
            title={t("create-miss-punch-request")}
            isOpen={visible}
            close={onCancel}
            toggle={onCancel}
            centered
        >
            <Form form={form} onFinish={onFinish}>
                <div className="mb-3">
                    <Label>{t("date")}</Label>
                    <DateInput disabled={true} value={moment(values?.date).toDate()} />
                </div>

                <div className="mb-3">
                    <Label>{t("start-time")}</Label>
                    <CustomTimeInput value={moment(values?.startDate).parseZone()} disabled={true} />
                </div>

                <Field
                    label={t("end-time")}
                    name="endDate"
                    rules={[
                        {
                            required: true,
                            message: t("required-end-time")
                        },
                        {
                            validator: (_, value) => {
                                if (value) {
                                    const { date, startDate, timezone } = values;
                                    let end = combineDateAndTime(moment(date), moment(value), timezone);
                                    if (moment(end).isSame(moment(startDate), "seconds")) {
                                        return Promise.reject(
                                            new Error(t("end-date-bigger-than-start-date"))
                                        );
                                    }
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <CustomTimeInput />
                </Field>

                <Field label={t("note")} name="note">
                    <Input
                        resize="none"
                        rows="7"
                        type="textarea"
                        className="h-100"
                        placeholder={t("note")}
                    />
                </Field>

                <div className="d-flex justify-content-end">
                    <Button
                        type="button"
                        color="muted"
                        disabled={loading}
                        onClick={onCancel}
                    >
                        {t("cancel")}
                    </Button>
                    <Button color="primary" loading={loading} disabled={loading}>
                        {t("save")}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}

export default MissPunchModal;
